import React from "react";
import { Card, Col, Container, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdCoPresent, MdOutlineToday } from "react-icons/md";
import { FaChartBar, FaClipboardCheck } from "react-icons/fa";
import "../../assets/styles/index.css";

const iconStyles = {
  faceAuth: { color: "#f4d033" }, // Yellow
  attendanceReports: { color: "#33a1ff" }, // Blue
  attendanceReview: { color: "#28a745" }, // Green
  dailyAttendance: { color: "#ffb300" }, // Amber
  monthlyAttendance: { color: "#8A2BE2" }, // BlueViolet - new color for monthly
};

const AdminAttendanceManagementScreen = () => {
  const menuItems = [
    {
      id: 1,
      title: "In & Out Entry",
      description: "Record attendance for employees using face authentication",
      icon: <MdCoPresent size={50} style={iconStyles.faceAuth} />,
      link: "/admin-face-auth",
    },
    {
      id: 2,
      title: "Attendance Reports",
      description: "View and analyze employee attendance records and reports",
      icon: <FaChartBar size={50} style={iconStyles.attendanceReports} />,
      link: "/admin-attendance-reports",
    },
    {
      id: 3,
      title: "Attendance Review",
      description: "Review and manage outdoor and indoor attendance submissions",
      icon: <FaClipboardCheck size={50} style={iconStyles.attendanceReview} />,
      link: "/admin-attendance-review",
    },
    {
      id: 4,
      title: "Admin Daily Attendance",
      description: "View your own daily attendance details",
      icon: <MdOutlineToday size={50} style={iconStyles.dailyAttendance} />,
      link: "/admin-daily-attendance",
    },
    {
      id: 5,
      title: "Admin Monthly Attendance",
      description: "View your own monthly attendance details",
      icon: <MdOutlineToday size={50} style={iconStyles.monthlyAttendance} />,
      link: "/admin-monthly-attendance",
    },
  ];

  return (
    <Container className="py-5">
      <h2 className="text-center mb-5">Admin Attendance Management</h2>
      <Row className="justify-content-center g-4">
        {menuItems.map((item) => (
          <Col key={item.id} xs={12} sm={10} md={6} lg={5} xl={4}>
            <Nav.Link as={Link} to={item.link} className="text-decoration-none h-100">
              <Card className="dashboard-card h-100 shadow-sm hover-card">
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-wrapper mb-4">
                    {item.icon}
                  </div>
                  <Card.Title className="h4 mb-3">{item.title}</Card.Title>
                  <Card.Text className="text-muted mb-4">
                    {item.description}
                  </Card.Text>
                  <div className="mt-auto">
                    <div className="btn btn-outline-primary px-4">
                      Access
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Nav.Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default AdminAttendanceManagementScreen; 